export const IP_TEST = "";
//nav
export const NAV_MODELS = [
  {
    id: "0",
    name: "首页",
    type: "home",
    icon:"icon-shouye",
    path: '/'
  },
  {
    id: "1",
    name: "关于我会",
    type: "info",
    icon:"icon-a-99-weiyuanhui",
    path: '/news/info/'
  },
  {
    id: "2",
    name: "通知公告",
    type: "view",
    icon:"icon-tongzhigonggao1",
    path: '/news/views/'
  },{
    id: "3",
    name: "培训项目",
    type: "view",
    icon:"icon-xiangmu1",
    path: '/news/views/'
  },
  {
    id: "4",
    name: "职业发展",
    type: "view",
    icon:"icon-zhiyeshengyamubiao",
    path: '/news/views/'
  },
  {
    id: "5",
    name: "信息咨询",
    type: "view",
    icon:"icon-zhihuitiku",
    path: '/news/views/'
  },
  {
    id: "6",
    name: "新闻动态",
    type: "view",
    icon:"icon-24gl-newspaper3",
    path: '/news/views/'
  },
  {
    id: "7",
    name: "会员服务",
    type: "info",
    icon:"icon-a-bianzu18",
    path: '/news/info/'
  },
  {
    id: "8",
    name: "在线考试",
    type: "link",
    icon:"icon-kaoshi",
    path: '/ExamLogin'
  },{
    id: "9",
    name: "信息查询",
    type: "link",
    icon:"icon-zhanghuxinxichaxun",
    path: '/selectinq'
  },
  {
    id: "10",
    name: "联系我们",
    type: "link",
    icon:"icon-lianxiwomen",
    path: '/ConcantUs'
  },
  
];
// NewsHot数据源
export const NEWS_HOT = ['通知公告'];
//InfoNews 数据源
export const INFO_NEWS = '新闻动态';
export const INFO_LIST = ['新闻动态','总会新闻'];
export const NEWCENTERLIST = ['智慧项目','智慧教育','智慧科技','信息咨询'];
export const NEWCENTERICON_LIST = ['icon-xiangmu','icon-jiaoyu','icon-keji'];
export const EDUNEWS_LIST = ['培训安排','授权课程','名单公示','成功案例'];
export const EDUNEWSICON_LIST = ['icon-gongzuoanpai','icon-kecheng','icon-xukegongshi','icon-icon_xinyong_xianxing_jijin-'];
export const PUBLIC_SERVICE = '公共服务';
export const EDIT_LIST = ['编辑出版']
//ad位置 位置F2
export const AD_POSITION = "企业推荐";
export const AllIcons ={
  "总会介绍":"icon-weixinpingtaijieshao",
  "项目组介绍":"icon-a-99-weiyuanhui",
  "我会章程":"icon-zhangcheng",
  "领导题词":"icon-zhutici",
  "组织机构":"icon-zuzhijigou-",
  "领导班子":"icon-iconhuodonganpai01",
  "信息咨询":"icon-zhihuigongcheng",
  "智慧科技":"icon-kejichengguo",
  "智慧项目":"icon-xiangmu",
  "智慧教育":"icon-jiaoyu",
  "入会说明":"icon-ruhui",
  "会员查询":"icon-huiyuanchaxun",
  "会员公约":"icon-hezuogongyue",
  "总会新闻":"icon-xinwen1",
  "新闻动态":"icon-24gl-newspaper3",
  "公示公告":"icon-tongzhigonggao",
  "声明公告":"icon-falvshengming",
  "培训安排":"icon-peixunanpai-01",
  "成功案例":"icon-jingdiananli",
  "授权课程":"icon-kecheng",
  "职业发展":"icon-zhiyefazhan",
  "职业规划":"icon-zhiyeshengyamubiao",
  "名单公示":"icon-mingdan",
  "证书说明":"icon-a-iconzigezhengshu",
  "搜索结果":"icon-sousuojieguo"
}